import { useMemo } from 'react'
import produce from 'immer'
import { Role } from '@feedyou/schema/dist/typescript/botFlow'

import { permissionsSchema } from './permissionsSchema'
import { getAllRolesUpToTarget } from '../../../../lib/userRole'
import { useFeature } from '../../../../store/features'

export const useSchema = () => {
  const shareMaxRole = useFeature('SHARE_MAX_ROLE') as Role
  const tokensMaxRole = useFeature('SHARE_TOKEN_MAX_ROLE') as Role

  return useMemo(() => {
    return produce(permissionsSchema, draft => {
      if (tokensMaxRole) {
        const tokenRoleSchema = draft.properties.tokens.items.properties.role
        // @ts-ignore
        tokenRoleSchema.enum = getAllRolesUpToTarget(tokensMaxRole, tokenRoleSchema.enum)
      }

      if (shareMaxRole) {
        const userRoleSchema = draft.properties.users.items.properties.role
        // @ts-ignore
        userRoleSchema.enum = getAllRolesUpToTarget(shareMaxRole, userRoleSchema.enum)
      }
    })
  }, [shareMaxRole, tokensMaxRole])
}
